// api/http.js
import axios from 'axios'
import { Message } from 'element-ui'

//export const baseURL='http://localhost:8080/splice'
export const baseURL='http://txzmap.com:8081/splice'
//export const baseURL='./'

export const service = axios.create({
  baseURL, // 根据环境变量设置的基础URL
  timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 比如：在这里添加 token 到 headers 中
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      config.headers['Authorization'] = `${jwt}`;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    let status = response.status
    if (status === 200 || status === 0) {
      //正确返回数据
      return response.data
    }
    return Promise.reject(response.data.info || "请求失败");
  }, // 假设API直接返回数据，而不是整个响应对象
  error => {
    // 对响应错误做点什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          //未授权 跳转到登陆
          break;

        default:
          break;
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      // 如果是超时错误
      Message.error({
        message: '请求超时，请检查您的网络连接或稍后再试！',
        duration: 3 * 1000 // 提示框显示时间，单位是毫秒
      })
    } else {
      // 其他错误
      console.error('请求配置错误', error.message)
    }
    return Promise.reject(error)
  }
);



// WEBPACK FOOTER //
// ./src/util/http.js